var o = /* @__PURE__ */ ((M) => (M.NORMAL = "normal", M.MINI = "mini", M.JUMBO = "jumbo", M.MAXI = "maxi", M))(o || {}), i = /* @__PURE__ */ ((M) => (M.NORMAL = "normal", M.MINI = "mini", M.JUMBO = "jumbo", M))(i || {});
export {
  o as M,
  i as o
};
